import React from 'react';
import { Card, CardContent } from './ui/card';
import { Mountain, Ruler } from 'lucide-react';

const SkiResorts = () => {
  const resorts = [
    {
      id: 'cerro-castor',
      name: 'CERRO CASTOR',
      location: 'USHUAIA, TIERRA DEL FUEGO',
      description: 'El centro de esquí más austral del mundo, con nieve de excelente calidad y temporada extendida.',
      descriptionEn: 'The southernmost ski resort in the world, with excellent snow quality and extended season.',
      altitude: '1057m',
      slopes: '35 pistas',
      image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/znm74ud3_CASTOR.jpg'
    },
    {
      id: 'cerro-catedral',
      name: 'CERRO CATEDRAL',
      location: 'BARILOCHE, RÍO NEGRO',
      description: 'El centro de esquí más grande de América del Sur, con infraestructura de clase mundial.',
      descriptionEn: 'The largest ski resort in South America, with world-class infrastructure.',
      altitude: '2100m',
      slopes: '120km pistas',
      image: 'https://images.unsplash.com/photo-1605540436563-5bca919ae766?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/prc9jn62_CATEDRAL.png'
    },
    {
      id: 'las-lenas',
      name: 'LAS LEÑAS',
      location: 'MALARGÜE, MENDOZA',
      description: 'Reconocido internacionalmente por su nieve polvo y terreno desafiante para expertos.',
      descriptionEn: 'Internationally recognized for its powder snow and challenging terrain for experts.',
      altitude: '3430m',
      slopes: '65 pistas',
      image: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/jyla3zh7_LAS%20LE%C3%91AS.jpg'
    },
    {
      id: 'chapelco',
      name: 'CERRO CHAPELCO',
      location: 'SAN MARTÍN DE LOS ANDES, NEUQUÉN',
      description: 'Centro familiar con vistas panorámicas al lago Lácar y bosques de araucarias.',
      descriptionEn: 'Family-friendly resort with panoramic views of Lake Lácar and araucaria forests.',
      altitude: '2000m',
      slopes: '40 pistas',
      image: 'https://images.unsplash.com/photo-1483921020237-2ff51e8e4b22?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/3qqqon7o_CHAPELCO.jpg'
    },
    {
      id: 'cerro-bayo',
      name: 'CERRO BAYO',
      location: 'VILLA LA ANGOSTURA, NEUQUÉN',
      description: 'Ambiente exclusivo y pistas para todos los niveles con vistas al lago Nahuel Huapi.',
      descriptionEn: 'Exclusive atmosphere and slopes for all levels with views of Lake Nahuel Huapi.',
      altitude: '1782m',
      slopes: '30 pistas',
      image: 'https://images.unsplash.com/photo-1544986581-efac024faf62?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/tij05u7n_BAYO.png'
    },
    {
      id: 'la-hoya',
      name: 'LA HOYA',
      location: 'ESQUEL, CHUBUT',
      description: 'Nieve de excelente calidad y ambiente tranquilo, ideal para familias.',
      descriptionEn: 'Excellent snow quality and peaceful atmosphere, ideal for families.',
      altitude: '2075m',
      slopes: '24 pistas',
      image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/ybttm3nn_LA%20HOYA.jpg'
    },
    {
      id: 'caviahue',
      name: 'CAVIAHUE',
      location: 'CAVIAHUE, NEUQUÉN',
      description: 'Centro volcánico con aguas termales naturales y nieve de gran calidad.',
      descriptionEn: 'Volcanic resort with natural hot springs and high-quality snow.',
      altitude: '2100m',
      slopes: '18 pistas',
      image: 'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/aidt0bss_CAVIAHUE.png'
    },
    {
      id: 'valle-nevado',
      name: 'VALLE NEVADO',
      location: 'SANTIAGO, CHILE',
      description: 'El centro de esquí más moderno de Sudamérica, con infraestructura de primer nivel y nieve excepcional.',
      descriptionEn: 'South America\'s most modern ski resort, with world-class infrastructure and exceptional snow.',
      altitude: '3670m',
      slopes: '37 pistas',
      image: 'https://images.unsplash.com/photo-1544986581-efac024faf62?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/4xe1i2xc_NEVADO.png'
    },
    {
      id: 'perito-moreno',
      name: 'PERITO MORENO',
      location: 'SANTA CRUZ, ARGENTINA',
      description: 'Centro de esquí de altura con vistas al glaciar Perito Moreno, experiencia única en la Patagonia.',
      descriptionEn: 'High-altitude ski resort with views of Perito Moreno glacier, unique Patagonian experience.',
      altitude: '1850m',
      slopes: '12 pistas',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80',
      logoUrl: 'https://customer-assets.emergentagent.com/job_ski-trip-planner/artifacts/3uy90t7g_PERITO%20MORENO.png'
    }
  ];

  return (
    <section id="resorts" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#003580] mb-4">
            CENTROS DE ESQUÍ DE ARGENTINA
          </h2>
          <p className="text-xl text-gray-600">Argentina's Premier Ski Resorts</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {resorts.map((resort) => (
            <Card
              key={resort.id}
              className="overflow-hidden border-2 border-gray-100 hover:border-[#FF6B35] transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-2 group"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={resort.image}
                  alt={resort.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#003580]/80 to-transparent"></div>
                
                {/* Logo del Centro como Marca de Agua en esquina superior derecha */}
                {resort.logoUrl ? (
                  <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-2 rounded-lg shadow-xl border border-gray-200">
                    <img
                      src={resort.logoUrl}
                      alt={`Logo ${resort.name}`}
                      className="h-8 w-auto object-contain"
                    />
                  </div>
                ) : (
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-xl border border-gray-200">
                    <span className="text-[#003580] font-black text-sm tracking-wide">{resort.name}</span>
                  </div>
                )}
                
                <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white drop-shadow-2xl">
                  {resort.name}
                </h3>
              </div>
              <CardContent className="p-6 space-y-4">
                <p className="text-sm font-semibold text-[#FF6B35]">{resort.location}</p>
                <div className="space-y-2">
                  <p className="text-gray-700 text-sm leading-relaxed">{resort.description}</p>
                  <p className="text-gray-500 text-xs leading-relaxed italic">{resort.descriptionEn}</p>
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div className="flex items-center space-x-2">
                    <Mountain className="w-5 h-5 text-[#003580]" />
                    <span className="text-sm font-semibold text-gray-700">{resort.altitude}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Ruler className="w-5 h-5 text-[#003580]" />
                    <span className="text-sm font-semibold text-gray-700">{resort.slopes}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkiResorts;
